import axios from 'axios'

const API_URL = '/api/images/'

// Get Basements
const getBasements = async () => {
	const response = await axios.get(API_URL + 'getBasements')

	return response.data
}

const basementsService = { getBasements }
export default basementsService
